// Badge for each rider dispatch status sent by the backend (who can take a ride now).
export const RIDER_STATUS = {
  free: { label: "Free", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300", dot: "bg-emerald-500" },
  on_trip: { label: "On a trip", cls: "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300", dot: "bg-amber-500" },
  offline: { label: "Offline", cls: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300", dot: "bg-gray-400" },
  pending: { label: "Pending", cls: "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400", dot: "bg-gray-300" },
  rejected: { label: "Rejected", cls: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300", dot: "bg-rose-400" },
  incomplete: { label: "Incomplete", cls: "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400", dot: "bg-gray-300" },
};

// Riders on the server's always-online list: offered every request whatever their toggle says.
export const ALWAYS_ONLINE_BADGE = { label: "Always online", cls: "bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300", dot: "bg-sky-500" };

// Approved riders: the only ones that can be nudged or assigned.
export const DISPATCHABLE = new Set(["free", "on_trip", "offline"]);

const CHARTER_SEATS = 4;

const seatsFree = (n) => (n === 0 ? "No seats free" : `${n} seat${n === 1 ? "" : "s"} free`);

/** Badge text for a rider on a trip, from the seat fields; null when the backend didn't send them. */
export function onTripLabel(rider) {
  if (rider?.onCharter === true) return "On a charter";
  if (typeof rider?.freeSeats !== "number") return null;
  return rider.freeSeats === 0 ? "On a trip · full" : `On a trip · ${seatsFree(rider.freeSeats).toLowerCase()}`;
}

/**
 * Can this rider be assigned or nudged for this booking, and if not, why.
 * Missing freeSeats/onCharter means an older backend: only a free rider can be assigned, as before.
 */
export function assignability(rider, booking) {
  const status = rider?.dispatchStatus;
  const waiting = booking?.status === "requested";
  const needed = booking?.isCharter ? CHARTER_SEATS : Math.max(1, Number(booking?.seats) || 1);
  const known = typeof rider?.freeSeats === "number";

  let seatReason = null;
  if (rider?.onCharter === true) seatReason = "On a charter";
  else if (known && rider.freeSeats < needed) {
    seatReason = rider.freeSeats === 0 ? "No seats free" : `Only ${seatsFree(rider.freeSeats).toLowerCase()}, this ride needs ${needed}`;
  }

  const canNudge = waiting && DISPATCHABLE.has(status) && !seatReason;
  let reason = null;
  if (!waiting) reason = "The ride is no longer waiting";
  else if (status === "offline") reason = "Offline";
  else if (!DISPATCHABLE.has(status)) reason = "This rider can't take rides";
  else if (seatReason) reason = seatReason;
  else if (status !== "free" && !known) reason = "Only a free rider can be assigned";

  return { canAssign: reason === null, canNudge, reason };
}
